import React from 'react';
import { Column, Row, Button, cls } from '../../packages/components';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import Assets from '../../requests/apa/Asset';
import PropTypes from 'prop-types';
import './styles/AAFModalCallCenter.scss';

const MAIN_CLASSNAME = 'aaf_app_modal-call-center';

const validFamily = (family, key ) => {
    return  Translator.get(`${family}_${key}`,'') !== '' ? `${family}_${key}` : key;
}

const Title = (family) => {
    return (
        <Column lg={12}>
            <p className={cls(`${MAIN_CLASSNAME} title`)}>
                {Translator.get(validFamily(family.family, 'subscription_modal_title_OfferCallCenter_label'))}
            </p>
        </Column>
    )
}

const OneText = (family) => {
    return (
        <Column lg={12} className={cls(`${MAIN_CLASSNAME} botton-1`)}>
            <Row className={cls(`${MAIN_CLASSNAME} OneText`)}>
                {Translator.get(validFamily(family.family, 'subscription_modal_description_OfferCallCenter_label'))}                
            </Row>
        </Column>
    )
}

const MiddleText = (family) => {
    return (
        <Column lg={12} className={cls(`${MAIN_CLASSNAME} botton-2`)}>
            <Row className={cls(`${MAIN_CLASSNAME} MiddleText`)}>
                {Translator.get(validFamily(family.family, 'subscription_modal_titleNumber_OfferCallCenter_label'))} 
            </Row>
            <Row className={cls(`${MAIN_CLASSNAME} MiddleNumber`)}>
                {Translator.get(validFamily(family.family, 'subscription_modal_number_OfferCallCenter_label'))} 
            </Row>
        </Column>
    )
}

const BottonText = (family) => {
    return (
        <Column lg={12} className={cls(`${MAIN_CLASSNAME} botton-3`)}>
            <Row className={cls(`${MAIN_CLASSNAME} BottonText`)}>
                {Translator.get(validFamily(family.family, 'subscription_modal_note_OfferCallCenter_label'))} 
            </Row>
        </Column>
    )
}

const BodyContent = ({ props }) => {
    return (
        <div>
            <Row>
                <Title family = {props.provider} />
            </Row>
            <Row>
                <OneText family = {props.provider} />
            </Row>
            <Row>
                <MiddleText  family = {props.provider}/>
            </Row>
            <Row>
                <BottonText family = {props.provider} />
            </Row>
            <Row>
            <Button
                activate
                type="button"
                variant="primary"
                className={cls('focusable', `${MAIN_CLASSNAME} button`)}
                onClick={(e) => {
                    props.handleClose(e, props.callback);
                }}
        
            >
                {Translator.get(
                    'subscription_modal_option_button_close'
                )}
            </Button>
            </Row>
        </div>
    );
};

const AAFModalCallCenter = (props = {}) => {
    const customizedClassName = `modal-button-return`;
    const p = {
        alwaysEnabled: true,
        buttonsAlign: 'vertical',
        aafNewStyle: true,
        className: 'aaf-modal',
        showLogo: true,
        yellowAction: (e) => props.handleClose(e),
        colorButtons: 
            [
                {
                    content: Translator.get('top_head_option_button_back', 'REGRESAR'),
                    props: {
                        color: 'yellow',
                        className: customizedClassName,
                        imgSrc: Assets.get('top_head_option_back', ''),
                        onClick: (e) => props.handleClose(e, props.callback),
                    },
                },
              ]
            ,
    };
    return (
        <ModalWrapper {...p}>
            <BodyContent props={props} />
        </ModalWrapper>
    );
};

AAFModalCallCenter.propTypes = {
    content: PropTypes.string,
    className: PropTypes.string,
};

export default withOnClose(AAFModalCallCenter);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalCallCenter.jsx